(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerCategoryDeleteController',CustomerCategoryDeleteController);

    CustomerCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerCategory'];

    function CustomerCategoryDeleteController($uibModalInstance, entity, CustomerCategory) {
        var vm = this;
        vm.customerCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CustomerCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
